
import { List, ListOrdered } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Editor } from '@tiptap/react';

export default function ListButtons({ editor }: { editor: Editor }) {
  return (
    <>
      <Button
        size="icon"
        variant={editor.isActive('bulletList') ? 'secondary' : 'ghost'}
        onClick={e => {
          e.preventDefault();
          editor.chain().focus().toggleBulletList().run();
        }}
        className="h-8 w-8"
        title="Bullet List"
        type="button"
      >
        <List className="h-4 w-4" />
      </Button>
      <Button
        size="icon"
        variant={editor.isActive('orderedList') ? 'secondary' : 'ghost'}
        onClick={e => {
          e.preventDefault();
          editor.chain().focus().toggleOrderedList().run();
        }}
        className="h-8 w-8"
        title="Ordered List"
        type="button"
      >
        <ListOrdered className="h-4 w-4" />
      </Button>
    </>
  );
}
